export default [
  {
    path: 'clientes',
    name: 'empresa.clientes',
    component: () =>
      import('@/components/shared/clientes/ClientesIndex.vue'),
  },

  {
    path: 'clientes/cuentas-corrientes',
    name: 'empresa.clientes.cuentascorrientes',
    component: () =>
      import('@/components/shared/clientes/reporte/ClientesCuentasCorrientes.vue'),
  },

  {
    path: 'clientes/nuevo',
    name: 'empresa.cliente.nuevo',
    component: () =>
      import('@/components/shared/clientes/ClienteCreate.vue'),
  },

  {
    path: 'clientes/:id_cliente',
    component: () =>
      import('@/components/shared/clientes/ClienteLayout.vue'),

    children: [
      {
        path: '',
        name: 'empresa.cliente.profile',
        component: () =>
          import('@/components/shared/clientes/ClienteProfile.vue'),
      },
      {
        path: 'editar',
        name: 'empresa.cliente.editar',
        component: () =>
          import('@/components/shared/clientes/ClienteUpdate.vue'),
      },
      {
        path: 'direcciones',
        name: 'empresa.cliente.direcciones',
        component: () =>
          import('@/components/shared/clientes/direcciones/ClienteDirecciones.vue'),
      },
      {
        path: 'contabilidad',
        name: 'empresa.cliente.contabilidad',
        component: () =>
          import('@/components/shared/clientes/contabilidad/ClienteContabilidad.vue'),
      },

      // Cuenta Corriente
      {
        path: 'cuentacorriente',
        name: 'empresa.cliente.cuentacorriente',
        component: () =>
          import('@/components/shared/clientes/cuentacorriente/ClienteCuentaCorriente.vue'),
      },
      {
        path: 'cuentacorriente/settings',
        name: 'empresa.cliente.cuentacorriente.settings',
        component: () =>
          import('@/components/shared/clientes/cuentacorriente/ClienteCuentaCorrienteSettings.vue'),
      },
      {
        path: 'cuentacorriente/actividad',
        name: 'empresa.cliente.cuentacorriente.movimientos',
        component: () =>
          import('@/components/shared/clientes/cuentacorriente/ClienteCuentaCorrienteMovimientos.vue'),
      },
      {
        path: 'cuentacorriente/actividad/detail/:movimiento_id',
        name: 'empresa.cliente.cuentacorriente.movimientos.detail',
        component: () =>
          import('@/components/shared/clientes/cuentacorriente/ClienteCuentaCorrienteMovimientosDetail.vue'),
      },
    ],
  },
];
